import actions from './actions'
import getters from './getters'
import * as types from './types'

const initialState = {
  facets: null,
  index: null
}

const state = {
  facets: null,
  index: null
}

const mutations = {
  [types.SET_FACET_INDEX](state, action) {
    state.index = action.index
  },
  [types.SET_FACET_ATTRIBUTE](state, action) {
    if (state.facets != null) {
      if (state.facets[action.attribute] == null) {
        state.facets = { ...state.facets, [action.attribute]: {
          isLoading: false,
          isOpen: false,
          availableValues: [],
          selectedValues: [],
          selectedObjectValues: [],
          errors: null
        } }
      } else {
        const existingFacet = { ...state.facets[action.attribute] }
        existingFacet.isOpen = true
        state.facets = { ...state.facets, [action.attribute]: existingFacet }
      }
    } else {
      state.facets = { ...state.facets, [action.attribute]: {
        isLoading: false,
        isOpen: false,
        availableValues: [],
        selectedValues: [],
        selectedObjectValues: [],
        errors: null
      } }
    }
  },
  [types.SET_FACET_IS_LOADING](state, action) {
    const facet = state.facets[action.attribute]
    facet.isLoading = action.flag
    state.facets = { ...state.facets, [action.attribute]: facet }
  },
  [types.SET_FACET_IS_OPEN](state, action) {
    const facet = state.facets[action.attribute]
    facet.isOpen = action.flag
    state.facets = { ...state.facets, [action.attribute]: facet }
  },
  [types.SET_FACET_AVAILABLE_VALUES](state, action) {
    const facet = state.facets[action.attribute]
    facet.availableValues = action.values
    state.facets = { ...state.facets, [action.attribute]: facet }
  },
  [types.SET_FACET_SELECTED_VALUE](state, action) {
    const facet = state.facets[action.attribute]
    const facetObject = state.facets[action.attribute].availableValues.find(({ value }) => {
      return value === action.value
    })
    facet.selectedValues.push(action.value)
    facet.selectedObjectValues.push(facetObject)
    state.facets = { ...state.facets, [action.attribute]: facet }
  },
  [types.REMOVE_FACET_SELECTED_VALUE](state, action) {
    const facet = state.facets[action.attribute]
    const facetObjectIndex = state.facets[action.attribute].selectedObjectValues.findIndex(({ value }) => {
      return value === action.value
    })
    const index = facet.selectedValues.indexOf(action.value)
    if ( index >= 0 ) {
      facet.selectedValues.splice(index, 1)
      facet.selectedObjectValues.splice(facetObjectIndex, 1)
      state.facets = { ...state.facets, [action.attribute]: facet }
    }
  },
  [types.REMOVE_ALL_SELECTED_VALUES](state, action) {
    let initialFacets = {}
    if (state.facets != null) {
      Object.keys(state.facets).forEach((key) => {
        if (action.notClearable.indexOf(key) >= 0) {
          initialFacets = { ...initialFacets, [key]: state.facets[key] }
        }
        const newFacetsObject = { ...state.facets[key], selectedValues: [] }
        initialFacets = { ...initialFacets, [key]: newFacetsObject }
      })
      state.facets = Object.assign(state.facets, initialFacets)
    }
  },
  [types.SET_FACET_ERROR](state, action) {
    const facet = state.facets[action.attribute]
    facet.error = action.error
    state.facets = { ...state.facets, [action.attribute]: facet }
  },
  [types.SET_RESET_STATE](state) {
    state = Object.assign(state, initialState)
  }
}

export const refinementListFilters = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
